export const SHOW_LOGIN_DIALOG = 'pageSegment/loginDialog/SHOW_LOGIN_DIALOG';
export const HIDE_LOGIN_DIALOG = 'pageSegment/loginDialog/HIDE_LOGIN_DIALOG';
